export const checkboxComponentKey = 'Checkbox';
export const numberComponentKey = 'Number';
export const dateComponentKey = 'Date';